<div
  id="highcharts-donut-signals"
  class="highcharts-donut-signals signal-count-container"
></div>
